import { render } from "./StepVideo.vue?vue&type=template&id=9511c35e"
import script from "./StepVideo.vue?vue&type=script&lang=js"
export * from "./StepVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__